import { render, staticRenderFns } from "./AmapPage.vue?vue&type=template&id=f401ba4e&scoped=true"
import script from "./AmapPage.vue?vue&type=script&lang=js"
export * from "./AmapPage.vue?vue&type=script&lang=js"
import style0 from "./AmapPage.vue?vue&type=style&index=0&id=f401ba4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f401ba4e",
  null
  
)

export default component.exports